
<div class="coupon-code-wrapper">
    <form [formGroup]="couponCodeForm">
        <input id="couponCodeField" type="text" formControlName="couponCodeField" class="form-control" [(ngModel)]="couponCode" (click)="resetMessage()"
        [placeholder]="'couponCode.placeholder' | translate"/>
        <button class="button secondary"
        (click)="useCouponCode()">
            <span [innerHTML]="'couponCode.useCouponCode' | translate"></span>
        </button>
        <div *ngIf="submitted && f.couponCodeField.errors"  class="invalid-feedback">
            <p *ngIf="f.couponCodeField.errors.pattern" [innerHTML]="'couponCode.invalid' | translate"></p>
        </div>
        <div *ngIf="submitted && (statusCode$ | async)  === 'Invalid'" class="invalid-feedback">
            <p [innerHTML]="'couponCode.invalid' | translate"></p>
        </div>
        <div *ngIf="submitted && (statusCode$ | async)  === 'Expired'" class="invalid-feedback">
            <p [innerHTML]="'couponCode.expired' | translate"></p>
        </div>
        <div *ngIf="submitted && (statusCode$ | async)  === 'Redeemed'" class="invalid-feedback">
            <p [innerHTML]="'couponCode.redeemed' | translate"></p>
        </div>
        <div *ngIf="submitted && (statusCode$ | async)  === 'Personalized'" class="invalid-feedback">
            <p [innerHTML]="'couponCode.personalized' | translate"></p>
        </div>
        <div *ngIf="submitted && (statusCode$ | async)  === 'AlreadyZero'" class="invalid-feedback">
            <p [innerHTML]="'couponCode.priceIsAlreadyZero' | translate"></p>
        </div>
        <div *ngIf="submitted && (statusCode$ | async)  === 'CodeIsTooLong'" class="invalid-feedback">
            <p [innerHTML]="'couponCode.codeIsTooLong' | translate"></p>
        </div>
        <div *ngIf="showUsedCode" class="coupon-code-used-text">
            <ng-container *ngFor="let code of couponCodeList$ | async; let i = index">
                <p> {{ 'couponCode.couponCode' | translate }}<span>{{code.code.replaceAll('"', '')}}</span>{{ 'couponCode.amountOf' | translate }}<da-coupon-code-value [codeValue]="code.value" [currency]="currency"></da-coupon-code-value><span [innerHTML]="currency"></span>{{ 'couponCode.isUsed' | translate }}<span class="close-icon" (click)="removeCouponCode(i)"></span></p>
            </ng-container>
        </div>
        <div *ngIf="showNewCouponCodeWillBeSentText" class="coupon-code-used-text">
            <p> {{ 'couponCode.newCodeWillBeSent' | translate }}<span>{{ formattedNewAmount$ | async }}</span><span [innerHTML]="currency"></span>{{ 'couponCode.sent' | translate }}</p>
        </div>
    </form>
</div>